import { render, staticRenderFns } from "./TopDetails.vue?vue&type=template&id=42aa338b&scoped=true&"
import script from "./TopDetails.vue?vue&type=script&lang=js&"
export * from "./TopDetails.vue?vue&type=script&lang=js&"
import style0 from "./TopDetails.vue?vue&type=style&index=0&id=42aa338b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa338b",
  null
  
)

export default component.exports